module.exports = __webpack_public_path__ + "img/couples-055.16162ea7.jpg";